<template lang="html">
  <div class="row">
    <div class="col-md-12">
      <table class="table table-condensed table-stripped table-bordered">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Slug</th>
            <th>Class</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="award in awards">
            <td>{{ award.name }}</td>
            <td>{{ award.slug }}</td>
            <td>{{ award.class }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as actions from '../../vuex/actions'
import {getConfigAwards} from '../../vuex/getters'
export default {
  vuex: {
    getters: {
      awards: getConfigAwards
    },
    actions
  },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  components: {}
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** AwardsList.vue?119f0faa
 **/